import axios from 'axios';
import React, { useEffect, useState } from 'react'
import FormDisplay from '../../../../../common/Form/FormDisplay';

const NoForm = () => {
  return (
    <>
    </>
  )
}

export default function Form({ project }) {

  const [form, setForm] = useState({});

  console.log(form)

  useEffect(() => {
    if (!project?.forms || project.forms.length === 0) return;

    const fid = project.forms[0].id;

    axios.get(`/api/form/form/${fid}`)
      .then(res => setForm(res.data))
      .catch(err => console.error("Failed to fetch form details:", err));
  }, [project]);

  return (
    <div>
      {Object.keys(form).length > 0 ?
      <FormDisplay form={form} /> :
      (<NoForm />)}
    </div>
  )
}
